import userData from '../data/users.json';

class UserService {
  constructor() {
    this.data = { ...userData };
    this.loadFromLocalStorage();
  }

  // Load data from localStorage if it exists
  loadFromLocalStorage() {
    const savedData = localStorage.getItem('venmo_user_data');
    if (savedData) {
      this.data = JSON.parse(savedData);
    }
  }

  // Save data to localStorage
  saveToLocalStorage() {
    localStorage.setItem('venmo_user_data', JSON.stringify(this.data));
  }

  // Authentication
  authenticate(email, password) {
    const user = this.data.users.find(u => u.email === email && u.password === password);
    if (user) {
      const { password: _, ...userWithoutPassword } = user;
      return userWithoutPassword;
    }
    return null;
  }

  // Get user by ID
  getUserById(id) {
    const user = this.data.users.find(u => u.id === id);
    if (user) {
      const { password: _, ...userWithoutPassword } = user;
      return userWithoutPassword;
    }
    return null;
  }

  // Get all users (without passwords)
  getAllUsers() {
    return this.data.users.map(user => {
      const { password: _, ...userWithoutPassword } = user;
      return userWithoutPassword;
    });
  }

  // Update user balance
  updateBalance(userId, amount) {
    const user = this.data.users.find(u => u.id === userId);
    if (user) {
      user.balance += amount;
      this.saveToLocalStorage();
      return user.balance;
    }
    return null;
  }

  // Create transaction
  createTransaction(transaction) {
    const newTransaction = {
      id: Date.now(),
      ...transaction,
      created_at: new Date().toISOString(),
      likes: [],
      comments: []
    };

    this.data.transactions.unshift(newTransaction);

    // Update balances
    if (transaction.type === 'payment') {
      this.updateBalance(transaction.sender_id, -transaction.amount);
      this.updateBalance(transaction.receiver_id, transaction.amount);
    }

    this.saveToLocalStorage();
    return newTransaction;
  }

  // Get transactions for a user
  getUserTransactions(userId) {
    return this.data.transactions
      .filter(t => t.sender_id === userId || t.receiver_id === userId)
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  }

  // Get all transactions (for feed)
  getAllTransactions() {
    return this.data.transactions
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  }

  // Add like to transaction
  addLike(transactionId, userId) {
    const transaction = this.data.transactions.find(t => t.id === transactionId);
    if (transaction && !transaction.likes.includes(userId)) {
      transaction.likes.push(userId);
      this.saveToLocalStorage();
    }
    return transaction;
  }

  // Remove like from transaction
  removeLike(transactionId, userId) {
    const transaction = this.data.transactions.find(t => t.id === transactionId);
    if (transaction) {
      transaction.likes = transaction.likes.filter(id => id !== userId);
      this.saveToLocalStorage();
    }
    return transaction;
  }

  // Add comment to transaction
  addComment(transactionId, userId, text) {
    const transaction = this.data.transactions.find(t => t.id === transactionId);
    if (transaction) {
      const newComment = {
        id: Date.now(),
        user_id: userId,
        text,
        created_at: new Date().toISOString()
      };
      transaction.comments.push(newComment);
      this.saveToLocalStorage();
    }
    return transaction;
  }
}

export const userService = new UserService();
export default userService;